import * as Urql from 'urql'

const getShuftiDocuments = `
  query {
    shuftiPro {
      shuftiProDocuments {
        type
        verified
        pending
        proofs {
          date
          url
          type
          status
          rejectionReason
        }
      }
    }  
  }
`

export function useDocuments() {
  const [response, refetchDocuments] = Urql.useQuery({
    query: getShuftiDocuments,
    requestPolicy: 'cache-and-network',
  })

  return [response?.data?.shuftiPro?.shuftiProDocuments, refetchDocuments]
}
